import UiHelper from './UiHelper';

class PrimaryNav
{
    static init()
    {
        // bind functions
        this.checkForSideNav = this.checkForSideNav.bind(this);

        // dom node references
        this.header = UiHelper.getNode('.js-site-header');
        this.headerInner = this.header.querySelector('.site-header__inner');
        this.branding = UiHelper.getNode('.js-header-branding');

        // listen to resize (throttled)
        UiHelper.registerHandler('resize', this.checkForSideNav, 'throttle');

        // wait for fonts to load before doing width calculations
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => {
                this.checkForSideNav(null);
            });
        } else {
            // fallback if Font Loading API not supported
            window.addEventListener('load', () => {
                this.checkForSideNav(null);
            });
        }

        this.header.classList.add('site-header--initiated');
    }


    static checkForSideNav(e)
    {
        if (this.header.offsetWidth < 576) return; // no need to do any calculations, always hamburger menu

        //const availableSpace = this.header.offsetWidth - this.branding.offsetWidth - UiHelper.getPrimaryNavWidth();
        const availableSpace = this.headerInner.offsetWidth - this.branding.offsetWidth - UiHelper.getPrimaryNavWidth();

        if (availableSpace < 30)
        {
            // /console.log('add hamburger class');
            this.header.classList.add('site-header--hamburger');
        }
        else
        {
            // console.log('remove hamburger class');
            this.header.classList.remove('site-header--hamburger');
        }
    }
}

export default PrimaryNav;
